var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowStepNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 6.7 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#454545;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_Copy",
    className: "st0",
    d: "M.4 11.7L6 6 .4.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_Copy_1_",
    className: "st0",
    d: "M.4 11.7L6 6 .4.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowStepNext);
export default __webpack_public_path__ + "static/media/ic_arrow_step_next.1d69f5cebddd5c0b8294d6fd8529bcb7.svg";
export { ForwardRef as ReactComponent };